/**
 * Shared helpers for the admin store modules (Zustand).
 */
import { API_URL } from "../../constants";
import authSession from "../../lib/authSession";
import { installAdminApiCache } from "../../lib/adminApiCache";

// Serve admin GET responses from a short-lived in-memory cache so revisiting an
// admin page does not refetch everything (see lib/adminApiCache.js).
installAdminApiCache();

/** Build the standard auth headers used by admin API calls. */
export function authHeaders(token) {
  const headers = { "Content-Type": "application/json" };
  if (token) headers.Authorization = `Bearer ${token}`;
  return headers;
}

/**
 * Resolve the current access token from the store, then the persisted session
 * (`authSession`, mirrored to localStorage so a reload keeps you signed in).
 */
export function resolveToken(get) {
  const state = get();
  return state.token || authSession.getToken() || "";
}

export { API_URL };
